/* eslint-disable react/no-unknown-property */
import React from "react";

interface Props {
  color?: string;
}

export const AcademiaBlockIcon = (props: Props) => (
  <svg
    width="28"
    height="26"
    viewBox="0 0 28 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26.6903 9.32975L13.9125 17.9548L1.13477 9.32975L13.9125 1.66309L26.6903 9.32975Z"
      stroke={props.color ?? "#2D5BFF"}
      stroke-width="1.53333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M22.2166 13.1631V18.3614C22.2166 19.6962 21.6944 20.978 20.7617 21.9329C18.9837 23.753 16.7002 24.6631 13.911 24.6631C11.1219 24.6631 8.83832 23.753 7.06036 21.9329C6.12764 20.978 5.60547 19.6962 5.60547 18.3614V13.1631"
      stroke={props.color ?? "#2D5BFF"}
      stroke-width="1.53333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M26.6895 9.32959V14.4407"
      stroke={props.color ?? "#2D5BFF"}
      stroke-width="1.53333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
